// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.result-container {
  height: calc(100vh - 180px);
  max-height: calc(100vh - 180px);
  overflow: auto;
  background-color: #EAEAEA;
}

.welcome {
  margin-left: -33px;
}

.welcomeText1 {
  margin-top: -11px;
  font-size: 16px;
}

.introduction-title {
  margin-top: 55px;
  font-weight: bold;
}

.feature {
  display: grid;
  place-content: center;
}

.welcomeText {
  top: 394px;
  left: 434px;
  width: 200px;
  height: 24px;
  /* UI Properties */
  text-align: left;
  font: normal normal bold 18px/24px Segoe UI, sans-serif;
  letter-spacing: 0px;
  color: #19191D;
  opacity: 1;
}

.Mui-disabled.pop-effect-dislike {
  color: #d32f2f !important;
}

.Mui-disabled.pop-effect-like {
  color: #2e7d32 !important;
}

.feature-card {
  background: #FFFFFF;
  border-radius: 6px 6px 6px 0px;
  opacity: 1;
  margin-right: 104px;
  box-shadow: 0px 3px 3px -2px rgba(0, 0, 0, 0.2), 0px 3px 4px 0px rgba(0, 0, 0, 0.14), 0px 1px 8px 0px rgba(0, 0, 0, 0.12);
  position: fixed;
}

.welcomefeature-card {
  background: #FFFFFF;
  border-radius: 6px 6px 6px 0px;
  opacity: 1;
  margin-right: -57%;
  box-shadow: 0px 3px 3px -2px rgba(0, 0, 0, 0.2), 0px 3px 4px 0px rgba(0, 0, 0, 0.14), 0px 1px 8px 0px rgba(0, 0, 0, 0.12);
}

.mobile-feature-card {
  background: #FFFFFF;
  border-radius: 6px 6px 6px 0px;
  opacity: 1;
  margin-left: -44px;
}

.question-div {
  display: flex;
  justify-content: center;
  align-items: center;
}

.welcome-mobile-feature-card {
  background: #FFFFFF;
  border-radius: 6px 6px 6px 0px;
  opacity: 1;
  margin-left: -44px;
  margin-right: -70px;
}

.previous {
  padding: 0;
}

.welcomeimgcard {
  float: right;
  top: 72px;
  background-color: rgba(0, 169, 224, 0.3019607843) !important;
}

.imgcard {
  float: right;
  top: 72px;
  margin-right: -18px;
  background-color: rgba(0, 169, 224, 0.3019607843) !important;
}

.next {
  padding: 0;
}

.question-bar {
  margin-top: 33px;
}

.mobile-question-bar {
  margin-left: 30px;
}

.navigation-row {
  position: absolute;
  height: 34px;
  width: 100%;
  top: calc(50% - 17px);
  margin-right: 0;
  margin-left: 0;
}

.list-item {
  display: inline-block;
}

.question-meta-info {
  font-size: 0.9rem;
}

.flex-middle-align {
  display: flex;
  align-items: center;
}

.newquestion {
  margin-left: 20%;
  padding: 0;
  max-width: 70%;
  min-width: 10%;
  float: right;
}

.newquestion > div > div > span > div {
  width: 120%;
}

.mobilenewquestion {
  margin-right: -55px;
  padding: 0;
  margin-bottom: 37px;
  width: -moz-fit-content;
  width: fit-content;
  min-width: 56px;
  float: right;
  margin-top: 19px;
  white-space: nowrap;
}

.pop-effect {
  transition: transform 0.2s ease-in-out;
}

.pop-effect:hover {
  transform: scale(1.1);
}

.newanswer {
  word-break: break-word;
  width: 92%;
  margin-top: 7%;
  float: left;
  padding: 0;
  align-items: center;
}

.newanswer1 {
  width: 117%;
  margin-top: 1%;
  float: left;
  padding: 0;
  align-items: center;
}

.respFont p {
  font-size: 16px !important;
}

.mobilenewanswer {
  margin-top: 2%;
  float: left;
  padding: 0;
  align-items: center;
  margin-left: -43px;
}

.bot {
  float: left;
  margin-top: 40%;
  left: 5px;
}

.blike {
  font-family: "Segoe UI", Arial, sans-serif;
  font-size: 14px;
  color: #19191D;
  height: 6px;
}

.blikes {
  font-family: "Segoe UI", Arial, sans-serif;
  font-size: 14px;
  color: #19191D;
  height: 13px;
}

.btt {
  color: #19191D;
  font-size: 12px;
  margin-top: 8px;
}

.vagueResponse {
  margin-top: 9px;
}

.btts {
  margin-top: 5px;
  font-size: 12px;
}

.btg {
  margin-left: 5px;
}

.feedback {
  font-size: 11px;
  margin-top: 5px;
}

.feedbackTextArea {
  height: 60px;
}

.feedbackDislike {
  font-size: 8px;
  margin-top: 5px;
}

.like {
  width: 30%;
  height: 50px;
}

.button {
  background-color: #04AA6D;
  border: none;
  color: white;
  padding: 20px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 4px 2px;
}

.button1 {
  border-radius: 2px;
}

.question-title-span {
  position: relative;
  display: block;
  font-size: 16px;
  text-align: left;
}

.mobile-question-title-span {
  position: relative;
  display: block;
  font-size: 14px;
  text-align: left;
}

.question-title-cip {
  position: absolute;
  right: 9px;
}

.sidebar {
  overflow-y: auto;
  height: calc(100vh - 150px);
}

.imgnew {
  background-color: #EAEAEA;
  padding-bottom: 27px;
}

.pdfClose {
  float: right;
}

.mobilePdfTextHeading {
  position: relative;
  top: 35px;
}

.loading-screen {
  background-color: black;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.loading-content {
  text-align: center;
}

.loading-text {
  color: #FFFFFF;
  margin-top: 10px;
  font-size: xx-large;
  font-family: "Segoe UI", Arial, sans-serif;
  font-weight: bolder;
}

.css-1um65qe-MuiButtonBase-root-MuiAccordionSummary-root.Mui-focusVisible {
  background-color: white !important;
}

.rightpanel {
  margin-right: 290px;
}

.rightpanelwelcome {
  margin-right: 425px;
}

.reponse {
  font-size: 16px !important;
}

.container {
  overflow-y: auto;
  margin-left: -99px;
  padding-left: 87px;
}`, "",{"version":3,"sources":["webpack://./src/components/home/home.component.scss"],"names":[],"mappings":"AAAA;EACE,2BAAA;EACA,+BAAA;EACA,cAAA;EACA,yBAAA;AACF;;AACA;EACE,kBAAA;AAEF;;AAAA;EACE,iBAAA;EACA,eAAA;AAGF;;AADA;EACE,gBAAA;EACA,iBAAA;AAIF;;AADA;EACE,aAAA;EACA,qBAAA;AAIF;;AAFA;EACE,UAAA;EACF,WAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,uDAAA;EACA,mBAAA;EACA,cAAA;EACA,UAAA;AAKA;;AAHA;EACE,yBAAA;AAMF;;AAJA;EACE,yBAAA;AAOF;;AALA;EAKE,mBAAA;EACA,8BAAA;EACA,UAAA;EACA,mBAAA;EACA,yHAAA;EACA,eAAA;AAIF;;AAFA;EACE,mBAAA;EACA,8BAAA;EACA,UAAA;EACA,kBAAA;EACA,yHAAA;AAKF;;AAHA;EACE,mBAAA;EACA,8BAAA;EACA,UAAA;EACA,kBAAA;AAMF;;AAFA;EAEE,aAAA;EACA,uBAAA;EACA,mBAAA;AAIF;;AAFA;EACE,mBAAA;EACA,8BAAA;EACA,UAAA;EACA,kBAAA;EACA,mBAAA;AAKF;;AAHA;EACE,UAAA;AAMF;;AAJA;EACE,YAAA;EACA,SAAA;EAEA,4DAAA;AAMF;;AAHA;EACE,YAAA;EACA,SAAA;EACA,mBAAA;EACA,4DAAA;AAMF;;AAFA;EACE,UAAA;AAKF;;AAHA;EACE,gBAAA;AAMF;;AAJA;EAEE,iBAAA;AAMF;;AAJA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,qBAAA;EACA,eAAA;EACA,cAAA;AAOF;;AAJA;EACE,qBAAA;AAOF;;AAJA;EACE,iBAAA;AAOF;;AAJA;EACE,aAAA;EACA,mBAAA;AAOF;;AALA;EAGG,gBAAA;EAED,UAAA;EAKA,cAAA;EAIF,cAAA;EACA,YAAA;AAFA;;AAUA;EACE,WAAA;AAPF;;AASA;EACG,mBAAA;EACD,UAAA;EACA,mBAAA;EACF,uBAAA;EAAA,kBAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;EACE,mBAAA;AANF;;AASA;EACE,sCAAA;AANF;;AAQA;EACE,qBAAA;AALF;;AAQA;EACE,sBAAA;EACA,UAAA;EACA,cAAA;EAEA,WAAA;EAEA,UAAA;EAGA,mBAAA;AATF;;AAaA;EACG,WAAA;EACD,cAAA;EACA,WAAA;EACA,UAAA;EACA,mBAAA;AAVF;;AAYA;EACE,0BAAA;AATF;;AAWA;EACE,cAAA;EAEA,WAAA;EACA,UAAA;EACA,mBAAA;EACA,kBAAA;AATF;;AAYA;EACE,WAAA;EACA,eAAA;EACA,SAAA;AATF;;AAYE;EACI,0CAAA;EACC,eAAA;EACA,cAAA;EACC,WAAA;AATR;;AAYO;EACG,0CAAA;EACC,eAAA;EACA,cAAA;EACA,YAAA;AATX;;AAYA;EAEG,cAAA;EACD,eAAA;EACA,eAAA;AAVF;;AAYA;EACE,eAAA;AATF;;AAWA;EACG,eAAA;EACD,eAAA;AARF;;AAWA;EACE,gBAAA;AARF;;AAUA;EACG,eAAA;EACD,eAAA;AAPF;;AASA;EACE,YAAA;AANF;;AAQA;EACE,cAAA;EACA,eAAA;AALF;;AAOA;EAEA,UAAA;EAEA,YAAA;AANA;;AAQA;EACE,yBAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,qBAAA;EACA,qBAAA;EACA,eAAA;EACA,eAAA;AALF;;AAQA;EAAU,kBAAA;AAJV;;AAMA;EACE,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAHF;;AAKA;EACE,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAFF;;AAKA;EACE,kBAAA;EACA,UAAA;AAFF;;AAKA;EACE,gBAAA;EACA,2BAAA;AAFF;;AAIA;EACE,yBAAA;EACA,oBAAA;AADF;;AAGA;EACE,YAAA;AAAF;;AAEA;EACE,kBAAA;EACA,SAAA;AACF;;AACA;EACE,uBAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAEF;;AAAA;EACE,kBAAA;AAGF;;AADA;EACE,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,0CAAA;EACA,mBAAA;AAIF;;AAFA;EACE,kCAAA;AAKF;;AAHA;EACE,mBAAA;AAMF;;AAJA;EACE,mBAAA;AAOF;;AALA;EACE,0BAAA;AAQF;;AANA;EACE,gBAAA;EACA,kBAAA;EACA,kBAAA;AASF","sourcesContent":[".result-container {\r\n  height: calc(100vh - 180px);\r\n  max-height: calc(100vh - 180px);\r\n  overflow: auto;\r\n  background-color: #EAEAEA;\r\n}\r\n.welcome{\r\n  margin-left: -33px;\r\n}\r\n.welcomeText1{\r\n  margin-top:-11px;\r\n  font-size:16px;\r\n}\r\n.introduction-title {\r\n  margin-top: 55px;\r\n  font-weight: bold;\r\n}\r\n\r\n.feature {\r\n  display: grid;\r\n  place-content: center;\r\n}\r\n.welcomeText{\r\n  top: 394px;\r\nleft: 434px;\r\nwidth: 200px;\r\nheight: 24px;\r\n/* UI Properties */\r\ntext-align: left;\r\nfont: normal normal bold 18px/24px Segoe UI, sans-serif;\r\nletter-spacing: 0px;\r\ncolor: #19191D;\r\nopacity: 1;\r\n}\r\n.Mui-disabled.pop-effect-dislike{\r\n  color: #d32f2f !important;\r\n}\r\n.Mui-disabled.pop-effect-like{\r\n  color: #2e7d32 !important;\r\n}\r\n.feature-card {\r\n  // top: 376px;\r\n  // left: 410px;\r\n // width: 474px;\r\n  // height: 82px;\r\n  background: #FFFFFF ;\r\n  border-radius: 6px 6px 6px 0px;\r\n  opacity: 1;\r\n  margin-right: 104px;\r\n  box-shadow: 0px 3px 3px -2px rgba(0,0,0,0.2), 0px 3px 4px 0px rgba(0,0,0,0.14), 0px 1px 8px 0px rgba(0,0,0,0.12);\r\n  position: fixed;\r\n}\r\n.welcomefeature-card{\r\n  background: #FFFFFF ;\r\n  border-radius: 6px 6px 6px 0px;\r\n  opacity: 1;\r\n  margin-right: -57%;\r\n  box-shadow: 0px 3px 3px -2px rgba(0,0,0,0.2), 0px 3px 4px 0px rgba(0,0,0,0.14), 0px 1px 8px 0px rgba(0,0,0,0.12);\r\n}\r\n.mobile-feature-card{\r\n  background: #FFFFFF ;\r\n  border-radius: 6px 6px 6px 0px;\r\n  opacity: 1;\r\n  margin-left: -44px;\r\n  // margin-right: 51px;\r\n // box-shadow: 0px 3px 3px -2px rgba(0,0,0,0.2), 0px 3px 4px 0px rgba(0,0,0,0.14), 0px 1px 8px 0px rgba(0,0,0,0.12);\r\n}\r\n.question-div {\r\n \r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n.welcome-mobile-feature-card{\r\n  background: #FFFFFF ;\r\n  border-radius: 6px 6px 6px 0px;\r\n  opacity: 1;\r\n  margin-left: -44px;\r\n  margin-right: -70px;\r\n}\r\n.previous {\r\n  padding: 0;\r\n}\r\n.welcomeimgcard{\r\n  float: right;\r\n  top: 72px;\r\n  // margin-right: -18px;\r\n  background-color: #00A9E04D !important;\r\n}\r\n\r\n.imgcard{\r\n  float: right;\r\n  top: 72px;\r\n  margin-right: -18px;\r\n  background-color: #00A9E04D !important;\r\n\r\n}\r\n\r\n.next {\r\n  padding: 0;\r\n}\r\n.question-bar{\r\n  margin-top:33px;\r\n}\r\n.mobile-question-bar{\r\n  //margin-top:33px;\r\n  margin-left: 30px;\r\n}\r\n.navigation-row {\r\n  position: absolute;\r\n  height: 34px;\r\n  width: 100%;\r\n  top: calc(50% - 17px);\r\n  margin-right: 0;\r\n  margin-left: 0;\r\n}\r\n\r\n.list-item {\r\n  display: inline-block;\r\n}\r\n\r\n.question-meta-info {\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.flex-middle-align {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n.newquestion{\r\n  \r\n // margin: 0;\r\n   margin-left: 20%;\r\n  // margin-right:-109px;\r\n  padding: 0;\r\n  //margin-bottom: 28px;\r\n  //display: flex;\r\n  //justify-content: flex-end;\r\n  //align-items: center;\r\n  max-width: 70%;\r\n //height: 100vh;\r\n//width: fit-content;\r\n//white-space: nowrap;\r\nmin-width: 10%;\r\nfloat: right;\r\n\r\n  // float:left;\r\n  // width:auto; \r\n  // min-width: 0px;\r\n  // text-align: \"center\";\r\n  // justify-content: \"flex-end\";\r\n}\r\n.newquestion>div>div>span>div {\r\n  width: 120%;\r\n}\r\n.mobilenewquestion{\r\n   margin-right:-55px;\r\n  padding: 0;\r\n  margin-bottom: 37px;\r\nwidth: fit-content;\r\nmin-width: 56px;\r\nfloat: right;\r\nmargin-top:19px;\r\n  white-space: nowrap;\r\n\r\n}\r\n.pop-effect{\r\n  transition: transform 0.2s ease-in-out;\r\n}\r\n.pop-effect:hover{\r\n  transform: scale(1.1);\r\n}\r\n\r\n.newanswer{\r\n  word-break: break-word;\r\n  width: 92%;\r\n  margin-top: 7%;\r\n \r\n  float: left;\r\n  //margin: 0;\r\n  padding: 0;\r\n//display: flex;\r\n  //justify-content: flex-start;\r\n  align-items: center;\r\n // height: 100vh;\r\n  //  width: 700px;\r\n}\r\n.newanswer1{\r\n   width: 117%;\r\n  margin-top: 1%;\r\n  float: left;\r\n  padding: 0;\r\n  align-items: center;\r\n}\r\n.respFont p{\r\n  font-size: 16px !important;\r\n}\r\n.mobilenewanswer{\r\n  margin-top: 2%;\r\n \r\n  float: left;\r\n  padding: 0;\r\n  align-items: center;\r\n  margin-left: -43px;\r\n\r\n}\r\n.bot{\r\n  float:left;\r\n  margin-top: 40%;\r\n  left: 5px;\r\n  //align-items: left;\r\n}\r\n  .blike{\r\n      font-family: 'Segoe UI', Arial, sans-serif;\r\n       font-size:14px;\r\n       color:#19191D;\r\n        height:6px;\r\n  }\r\n\r\n       .blikes{\r\n          font-family: 'Segoe UI', Arial, sans-serif;\r\n           font-size:14px;\r\n           color:#19191D;\r\n           height: 13px;\r\n\r\n}\r\n.btt{\r\n   \r\n   color:#19191D;\r\n  font-size: 12px;\r\n  margin-top:8px;\r\n}\r\n.vagueResponse{\r\n  margin-top: 9px;\r\n}\r\n.btts{\r\n   margin-top: 5px;\r\n  font-size: 12px;\r\n}\r\n\r\n.btg{\r\n  margin-left: 5px;\r\n}\r\n.feedback{\r\n   font-size: 11px;\r\n  margin-top:5px;\r\n}\r\n.feedbackTextArea{\r\n  height: 60px;\r\n}\r\n.feedbackDislike{\r\n  font-size: 8px;\r\n  margin-top:5px;\r\n}\r\n.like{\r\n  \r\nwidth: 30%;\r\n\r\nheight: 50px;\r\n}\r\n.button {\r\n  background-color: #04AA6D;\r\n  border: none;\r\n  color: white;\r\n  padding: 20px;\r\n  text-align: center;\r\n  text-decoration: none;\r\n  display: inline-block;\r\n  font-size: 16px;\r\n  margin: 4px 2px;\r\n}\r\n\r\n.button1 {border-radius: 2px;}\r\n\r\n.question-title-span {\r\n  position: relative;\r\n  display: block;\r\n  font-size: 16px;\r\n  text-align: left;\r\n}\r\n.mobile-question-title-span{\r\n  position: relative;\r\n  display: block;\r\n  font-size: 14px;\r\n  text-align: left;\r\n}\r\n\r\n.question-title-cip {\r\n  position: absolute;\r\n  right: 9px;\r\n}\r\n\r\n.sidebar {\r\n  overflow-y: auto;\r\n  height: calc(100vh - 150px);\r\n}\r\n.imgnew{\r\n  background-color: #EAEAEA;\r\n  padding-bottom: 27px;\r\n  }\r\n.pdfClose{\r\n  float:right;\r\n}\r\n.mobilePdfTextHeading{\r\n  position:relative;\r\n  top:35px;\r\n}\r\n.loading-screen{\r\n  background-color: black;\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n.loading-content{\r\n  text-align: center;\r\n}\r\n.loading-text{\r\n  color:#FFFFFF;\r\n  margin-top: 10px;\r\n  font-size:xx-large;\r\n  font-family: 'Segoe UI', Arial, sans-serif;\r\n  font-weight: bolder;\r\n}\r\n.css-1um65qe-MuiButtonBase-root-MuiAccordionSummary-root.Mui-focusVisible {\r\n  background-color:#FFFF !important;\r\n}\r\n.rightpanel{\r\n  margin-right:290px;\r\n}\r\n.rightpanelwelcome{\r\n  margin-right:425px;\r\n}\r\n.reponse{\r\n  font-size:16px !important;\r\n}\r\n.container{\r\n  overflow-y: auto;\r\n  margin-left: -99px;\r\n  padding-left:87px ;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
